<template>
	<div class="free-content" v-html="content" />
</template>

<script>
/**
 * A free-content component with Faset text styling built in.
 */
export default {
	name: "FreeContent",

	props: {
		/**
		 * String of HTML content.
		 */
		content: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss">
.free-content {
	& > p {
		@include p2;
		max-width: none;
	}

	& > a,
	& > p a {
		color: $color--red-3;

		&:hover {
			text-decoration: underline;
		}
	}

	& > h2 {
		@include h2;
		margin-bottom: 0;
	}

	& > h3 {
		@include h3;
		margin-bottom: 0;
	}

	& > h4 {
		@include h4;
		margin-bottom: 0;
	}

	& > h5 {
		@include h5;
		margin-bottom: 0;
	}

	& > h6 {
		@include h6;
		margin-bottom: 0;
	}

	& > .p1 {
		@include p1;
		margin-bottom: 0;
	}

	& > .p2 {
		@include p2;
		margin-bottom: 0;
	}

	& > .p3 {
		@include p3;
		margin-bottom: 0;
	}

	& > .p4 {
		@include p4;
		margin-bottom: 0;
	}

	& > .align-right {
		text-align: right;
	}

	& > .align-left {
		text-align: left;
	}

	& > .align-center {
		text-align: center;
	}

	/* anything following p */
	& > p + * {
		margin-top: 16px;
	}

	/* p following antying */
	& > * + p {
		margin-top: 16px;
	}

	/* h2, h3 following anything */
	& > * + h2,
	& > * + h3 {
		margin-top: 48px;
	}

	/* anything following h2, h3 */
	& > h2 + *,
	& > h3 + * {
		margin-top: 24px;
	}

	/* h4, h5 following anything */
	& > * + h4,
	& > * + h5 {
		margin-top: 40px;
	}

	/* anything following h4, h5 */
	& > h4 + *,
	& > h5 + * {
		margin-top: 16px;
	}

	& > *:first-child {
		margin-top: 0 !important;
	}
}
</style>
